export enum OrdinalKind {
    Default,
    Number
}
